export default __webpack_public_path__ + "static/media/old-portfolio.cc7aa150.jpg";